export default __webpack_public_path__ + "static/starielogo-ae43018eccd48e47fcd8e5113e24a7a3.png";